window.VH = window.VH === undefined ? {} : window.VH;
VH.Helper = {
    _w : window,
    w : $(window),
    _d : document,
    d : $(document),
    b : $('body'),
    wr : $('#wrapper'),

    onInModalAClick : function onInModalAClick(event)
    {
        let t = $(this),
            href = t.attr('href');

        if (href !== undefined && href !== '#') {
            event.stopPropagation();
            return true;
        }
    },

    initContentTooltip : function initContentTooltip()
    {
        $('.uContentTooltip').each(function() {
            let t = $(this);
            t.tooltip({title:t.html()});
        });
    },

    fixDateRangeCurrentDate : function fixDateRangeCurrentDate(ev, picker)
    {
        if ($(this).val() === "") {
            picker.callback(picker.startDate.clone(), picker.endDate.clone(), picker.chosenLabel);
        }
    },

    initCopyClipboard : function initCopyClipboard()
    {
        let _t = VH.Helper;
        _t.b.on('click', '.copyClipboard', _t.copyClipboard);
    },

    copyClipboard : function copyClipboard()
    {
        navigator.clipboard.writeText($(this).data('clipboard')).then(function() {
            bootbox.alert("Скопировано");
        }, function() {
        });
        return false;
    },

    executeFunctionByName : function executeFunctionByName(functionName, context /*, args */)
    {
        let _t = VH.Helper,
            args = Array.prototype.slice.call(arguments, 2),
            namespaces = functionName.split("."),
            func = namespaces.pop();
        context = context === undefined ? _t._w : context;

        for (let i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }
        return context[func].apply(context, args);
    },

    initAjaxPost : function initAjaxPost()
    {
        let _t = VH.Helper;
        _t.b.on('click', '[data-ajax-method="post"]', _t.ajaxPost);
    },

    ajaxPost : function ajaxPost(event)
    {
        let _t = VH.Helper,
            t = $(this),
            url = t.attr('href'),
            params = t.data('params'),
            callback = t.data('ajax-callback'),
            confirm = t.data('ajax-confirm'),
            postMethod
        ;
        params = params === undefined ? {} : params;
        callback = callback !== undefined && callback.length > 0 ? callback : false;
        confirm = confirm !== undefined ? confirm : false;
        postMethod = function () {
            $.post(url, params, function (result) {
                if (callback !== false) {
                    _t.executeFunctionByName(callback, _t._w, event, t, result);
                }
            });
        };
        if (confirm) {
            bootbox.confirm({
                message : confirm,
                callback : function (result) {
                    if (result) {
                        postMethod();
                    }
                }
            });
        } else {
            postMethod();
        }

        event.stopImmediatePropagation();
        return false;
    }

};
